<template>
  <div class="bg-gray">
    <navigation-bar :mode="'Admin'"></navigation-bar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <div class="row">
                  <div class="col-sm-12">
                    <h1 style="float:left;">Services</h1>
                    <button @click="addService" style="float:left;margin-left:10px;margin-top:5px;" type="button" class="btn btn-primary btn-blue" aria-label="Left Align">
                      <i class="fa fa-plus fa-sm"></i>
                    </button>
                  </div>
                </div>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th class="hidden-sm" scope="col">Active</th>
                      <th class="hidden-sm" scope="col">Account Required</th>
                      <th class="hidden-sm" scope="col">Archive</th>
                      <th class="hidden-sm" scope="col">Remove After 6 Months</th>
                      <th scope="col">Edit</th>
                      <th scope="col">Fields</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="service in store.state.services" :key="service.id">
                      <td>{{service.name}}</td>
                      <td class="hidden-sm">{{service.active == 1 ? 'Yes' : 'No'}}</td>
                      <td class="hidden-sm">{{service.accountRequired == 1 ? 'Yes' : 'No'}}</td>
                      <td class="hidden-sm">{{service.archiveAfterCompletion == 1 ? 'Yes' : 'No'}}</td>
                      <td class="hidden-sm">{{service.removeAfter6Months == 1 ? 'Yes' : 'No'}}</td>
                      <td><button @click="edit(service.id)" class="btn btn-primary btn-blue">Edit</button></td>
                      <td><button @click="fields(service.id)" class="btn btn-primary btn-blue">Fields</button></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar.vue'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AdminServicesStore from './AdminServicesStore'
import AdminPermissionsUtils from './AdminPermissionsUtils'

export default {
  name: 'AdminServices',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: AdminServicesStore,
      adminUtils: AdminPermissionsUtils
    }
  },
  mounted () {
    this.adminUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;
      
      this.getServices();
    },(err) => {
      this.$toasted.show(err, { type: 'error', duration: 2500 })
      this.nav.goAdminLogin(this);
    })
  },
  methods: {
    getServices: function() {
      let self = this
      this.store.getServices((data) => {
      }, (err) => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    },
    addService: function () {
      this.nav.addService(this)
    },
    edit: function(serviceId) {
      this.nav.editService(this,serviceId)
    },
    fields: function(serviceId) {
      this.nav.serviceFields(this,serviceId)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminServices.vue